import React, { useMemo } from 'react';
import { getPageCapabilities, getPageTitle } from '../../../utils';
import { useAssessmentContext } from '../../../AssessmentContext';
import { Card, CardBody } from 'reactstrap';
import CapabilityResults from './CapabilityResults';

import AdditionalElementResults from './AdditionalElementResults';

import styles from '../Review.module.scss';

function CapabilitiesPageResults({ page }) {
  const { capabilitySets } = useAssessmentContext();

  const capabilitySet = useMemo(() => {
    return capabilitySets[page.capabilitySetId];
  }, [capabilitySets, page.capabilitySetId]);

  const pageCapabilities = useMemo(() => {
    return getPageCapabilities(capabilitySet, page.selectedCapabilities);
  }, [capabilitySet, page.selectedCapabilities]);

  const pageTitle = getPageTitle(page, capabilitySets);

  return (
    <Card>
      <CardBody>
        <div className={styles['capabilities-page-results-header']}>
          <h3>{pageTitle}</h3>
          {/* Only admins see which capability set a page asks about */}
          {capabilitySet?.name && capabilitySet.name !== pageTitle && (
            <div className={styles['capabilities-page-results-set-name']}>
              {capabilitySet.name}
            </div>
          )}
        </div>
        {pageCapabilities.map((capability) => (
          <CapabilityResults
            key={capability.id}
            capability={capability}
            elements={page.capabilityElements}
          />
        ))}
        {page.capabilityElements.map((capabilityElement) => (
          <AdditionalElementResults
            key={capabilityElement.guid}
            page={page}
            capabilityElement={capabilityElement}
          />
        ))}
      </CardBody>
    </Card>
  );
}

export default CapabilitiesPageResults;
